/**
 * Las horas de una visita, como las dice la gente en Cartago.
 *
 * La fecha y la hora se escogen en hora de Colombia (UTC−5, sin horario de
 * verano), así que el instante se arma con el desfase fijo: escoger «8:00»
 * en un computador con otra zona horaria sigue siendo las 8:00 de allá.
 */

const ZONA = 'America/Bogota'

/** «2026-10-06» + «08:00» → instante ISO en hora de Colombia. */
export function instante(fecha: string, hora: string): string {
  return new Date(`${fecha}T${hora}:00-05:00`).toISOString()
}

/** El día (aaaa-mm-dd) y la hora (hh:mm) en Colombia de un instante. */
export function partes(iso: string): { fecha: string; hora: string } {
  const d = new Date(iso)
  const fecha = new Intl.DateTimeFormat('en-CA', {
    timeZone: ZONA,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d)
  const hora = new Intl.DateTimeFormat('en-GB', {
    timeZone: ZONA,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(d)
  return { fecha, hora }
}

/** «lunes 6 de oct · 8:00 a. m.» */
export function cuandoEs(iso: string): string {
  const d = new Date(iso)
  const dia = new Intl.DateTimeFormat('es-CO', {
    timeZone: ZONA,
    weekday: 'long',
    day: 'numeric',
    month: 'short',
  }).format(d)
  const hora = new Intl.DateTimeFormat('es-CO', {
    timeZone: ZONA,
    hour: 'numeric',
    minute: '2-digit',
  }).format(d)
  return `${dia} · ${hora}`
}

/** 1.5 → «1,5 h»; 0.5 → «30 min». */
export function duracion(horas: number | null): string {
  if (!horas) return '1 h'
  if (horas < 1) return `${Math.round(horas * 60)} min`
  return `${String(horas).replace('.', ',')} h`
}

/** El día de hoy en Colombia (aaaa-mm-dd). */
export function hoyEnColombia(): string {
  return partes(new Date().toISOString()).fecha
}

export const DURACIONES = [0.5, 1, 1.5, 2, 3, 4, 6, 8] as const
